module.exports = __webpack_public_path__ + "media/sangban.b8926914.wav";